import { initErrorTracking } from './error-tracking';
import { initPageLoadTime } from './page-performance';

let started = false;

export function initHeadMonitoring(): void {
  if (started) return;
  started = true;
  try {
    initErrorTracking();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[head-monitoring] error-tracking init failed', e);
  }
  try {
    initPageLoadTime();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[head-monitoring] page-performance init failed', e);
  }
}

export function __resetHeadMonitoringForTests(): void {
  started = false;
}

initHeadMonitoring();
